import React from 'react'
import Typography from '@mui/material/Typography'
import useFetchData from '../../../../../../hooks/useFetchData'
import InputField from '../../../../../FormControl/input/InputField'
import SelectField from '../../../../../FormControl/input/SelectField'

const FormBasicInformation = ({ form = {}, errors = {}, onChange, type }) => {
  const { isLoading: isLoadingTypes, data: dataTypes } = useFetchData('/periodical-report/setting/type')

  return (
    <>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Code
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.code}</Typography>
        ) : (
          <InputField
            id='code'
            name='code'
            value={form.code}
            error={errors?.code}
            helperText={errors?.code}
            onChange={(e) => onChange('code', e.target.value)}
            fullWidth
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Name
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.name}</Typography>
        ) : (
          <InputField
            id='name'
            name='name'
            value={form.name}
            error={errors?.name}
            helperText={errors?.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
          />
        )}
      </div>
      <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
        Type
      </Typography>
      <div className='col-span-3'>
        {type === 'preview' ? (
          <Typography>{form.type}</Typography>
        ) : (
          <SelectField
            id='type'
            name='type'
            value={form.type}
            error={errors?.type}
            helperText={errors?.type}
            onChange={(e) => onChange('type', e.target.value)}
            placeholder='Choose a type'
            options={
              dataTypes
                ?.filter((item) => (form.curriculumId ? item.curriculumId === item.curriculumId : true))
                .map((item) => ({ value: item.code, label: item.name })) || []
            }
            loading={isLoadingTypes}
            fullWidth
          />
        )}
      </div>
    </>
  )
}

export default FormBasicInformation
